import React from "react";
import Loadable from "../../react-loadable";

const Com = Loadable({
  loader: () => import("./ShowUrl"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
// import Com from './ShowUrl';

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-show-url/index.js